import { useState, useEffect } from "react";
import styled from "styled-components";

function Footer() {
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState(""); // "register" | "nominate"
    
useEffect(() => {
  if (!showForm) return;

  // REGISTER FORM (iframe embed)
  if (formType === "register") {
    if (!document.getElementById("hubspot-iframe-script")) {
      const script = document.createElement("script");
      script.src = "https://js-na2.hsforms.net/forms/embed/46890133.js";
      script.defer = true;
      script.id = "hubspot-iframe-script";
      document.body.appendChild(script);
    }
  }

  // NOMINATE FORM (existing one)
  if (formType === "nominate") {
    const loadForm = () => {
      if (window.hbspt) {
        const container = document.getElementById("about-hubspot-form");
        if (container) {
          container.innerHTML = "";

          window.hbspt.forms.create({
            region: "na2",
            portalId: "46890133",
            formId: "425f93b6-55f2-4ad3-9471-590c5cccc06f",
            target: "#about-hubspot-form",
          });
        }
      }
    };

    if (window.hbspt) {
      loadForm();
    } else {
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/embed/v2.js";
      script.async = true;
      script.onload = loadForm;
      document.body.appendChild(script);
    }
  }
}, [showForm, formType]);
  return (
    <Wrap>
      <Text>Be part of India’s leading technology and impact platform.</Text>

<Buttons>
  {/* <Primary
    onClick={() => {
      setFormType("register");
      setShowForm(true);
    }}
  >
    Register Now
  </Primary> */}

</Buttons>
              {/* HUBSPOT FORM MODAL */}
        {showForm && (
  <FormModalOverlay onClick={() => setShowForm(false)}>
    <FormModalContent onClick={(e) => e.stopPropagation()}>
      <FormCloseBtn onClick={() => setShowForm(false)}>
        ✕
      </FormCloseBtn>

      {/* REGISTER FORM */}
      {formType === "register" && (
        <div
          className="hs-form-frame"
          data-region="na2"
          data-form-id="b67c2bd0-1361-4824-83f4-64ea65ea391f"
          data-portal-id="46890133"
        ></div>
      )}

      {/* NOMINATE FORM */}
      {formType === "nominate" && (
        <div id="about-hubspot-form"></div>
      )}
    </FormModalContent>
  </FormModalOverlay>
)}
    </Wrap>
  );
}

export default Footer;

/* ================= STYLES ================= */

const Wrap = styled.footer`
  background: linear-gradient(135deg,#0f172a,#1e293b);
  color: #e2e8f0;
  text-align: center;
  padding: 60px 20px 30px;
  font-family:'Poppins',sans-serif;

  @media (max-width: 768px) {
      padding: 10px 10px 10px;
  }
`;

const Text = styled.h3`
  font-size: 26px;
  font-weight:600;
  margin-bottom:30px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 4px;
  }
`;

const Buttons = styled.div`
  display:flex;
  gap:25px;
  justify-content:center;
  flex-wrap:wrap;
  margin-bottom:40px;

  @media (max-width: 768px) {
    gap: 6px;
    margin-bottom: 6px;
  }
`;

const Primary = styled.a`
  padding:16px 42px;
  border-radius:40px;
  text-decoration:none;
  font-weight:600;
  color:white;
  background: linear-gradient(90deg,#d6a54f,#bd8a32);
  transition:.35s;
  border:2px solid #bd8a32;

  &:hover{
    transform:translateY(-3px);
    box-shadow:0 10px 25px rgba(0,0,0,.25);
  }

  @media (max-width: 768px) {
    padding: 6px 24px;
    font-size: 12px;
  }
`;

const Outline = styled.button`
  padding: 16px 42px;
  border-radius:40px;
  text-decoration:none;
  font-weight:600;
  color:#fff;
  border:2px solid #e5e7eb;
  background:transparent;
  transition:.35s;
    font-family: inherit;
  font-size: inherit;

  &:hover{
    background:#fff;
    transform:translateY(-3px);
    color:#9E3B3B;
    box-shadow:0 10px 25px rgba(0,0,0,.15);
  }
  @media (max-width: 768px) {
    padding: 6px 16px;
    font-size: 12px;
  }
`;

const FormModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const FormModalContent = styled.div`
  background: #ffffff;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 14px;
  padding: 40px 30px;
  position: relative;
`;

const FormCloseBtn = styled.button`
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);

  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: #d6a54f;
  color: white;
  font-size: 18px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #bd8a32;
    transform: translateX(-50%) scale(1.1);
  }
`;